import React from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';

interface BreadcrumbItem {
  label: string;
  href?: string;
}

interface BreadcrumbProps {
  items: BreadcrumbItem[];
}

const Breadcrumb: React.FC<BreadcrumbProps> = ({ items }) => {
  return (
    <nav aria-label="Breadcrumb" className="flex items-center gap-2 flex-wrap">
      <Link
        to="/"
        className="font-sans text-[10px] uppercase tracking-[0.3em] text-white/50 hover:text-gold transition-colors duration-300"
      >
        Home
      </Link>
      {items.map((item, i) => (
        <React.Fragment key={i}>
          <ChevronRight className="w-3 h-3 text-white/15 flex-shrink-0" />
          {item.href ? (
            <Link
              to={item.href}
              className="font-sans text-[10px] uppercase tracking-[0.3em] text-white/50 hover:text-gold transition-colors duration-300"
            >
              {item.label}
            </Link>
          ) : (
            <span className="font-sans text-[10px] uppercase tracking-[0.3em] text-white/60">
              {item.label}
            </span>
          )}
        </React.Fragment>
      ))}
    </nav>
  );
};

export default Breadcrumb;
